// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (max-width:1023px){.button[data-v-3bb9322e]{padding:1.375rem 1.75rem}}", ""]);
// Exports
module.exports = exports;
